import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router';
import useTreatments from '../../store/treatments/treatmentsContext';
import useApp from '../../store/app/appContext';
import { MoonLoader } from 'react-spinners';
import { COLORS } from '../../config';
import axios from 'axios';
import { useTable } from 'react-table';

const Styles = styled.div`
  table { border-collapse: separate; }
  td:first-child { padding-left: 10px; }
  td:first-child { border-top-left-radius: 10px; }
  td:first-child { border-bottom-left-radius: 10px; }
  td:last-child { border-top-right-radius: 10px; }
  td:last-child { border-bottom-right-radius: 10px; }
`;

function PendingPayments() {
  const { getUnpaidUserTransactions, getTreatmentInfo } = useTreatments();

  const [unpaidTransactions, setUnpaidTreatmentTransactions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  
  const { appState: { user, userAccount }} = useApp();

  const history = useHistory();

  useEffect(() => {
    if (unpaidTransactions.length) return;
    let source = axios.CancelToken.source();
    if (userAccount.isPatient) getUnpaidUserTransactions(source).then(data => {
      const transactions = data;
      if (transactions) {
        setUnpaidTreatmentTransactions(transactions);
      }
      setIsLoading(false);
    }).catch(err => {
      setIsLoading(false);
    }); 
    
    return () => {
      source.cancel();
    }
  }, [userAccount])

  const columns = React.useMemo(
    () => [
      {
        Header: 'Item',
        accessor: 'name',
      },
      {
        Header: 'Amount',
        accessor: 'amount',
      },
    ], []
  );

  const data = React.useMemo(() => [], [unpaidTransactions]);

  if (unpaidTransactions.length && !data.length) {
    unpaidTransactions.map(transaction => {
      return data.push({
        id: transaction._id,
        name: transaction.name,
        amount: transaction.amount,
        treatmentId: transaction.treatment_id
      })
    })
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  })

  const handlePayClick = async (treatmentId) => {
    const treatmentInfo = await getTreatmentInfo(treatmentId)
    history.push({
      pathname: "/my-treatments/checkout",
      state: { treatmentInfo },
    })
  }
  
  const renderTable = () => {
    return (
      <Styles>
        <div className='overflow-x-scroll '>
          <table {...getTableProps()} className='w-full border-collapse '>
            <thead>
              {headerGroups.map(headerGroup => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map(column => {
                    return (<th {...column.getHeaderProps()} className={`${column.id === 'name' ? 'pl-2.5 ' : 'pl-2'} text-left`}>{column.render('Header')}</th>)
                  })}
                  <th />
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()} className=''>
              {rows.map((row, i) => {
                prepareRow(row)
                return (
                  <tr {...row.getRowProps()} className={`${row.id % 2 === 0 ? '' : 'bg-gray-100'} `}>
                    {row.cells.map(cell => {
                      if (cell.column.id === 'amount') {
                        return (
                          <td {...cell.getCellProps()} className={`text-gray-600 py-2 pl-2 `}>
                          {new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(cell.value)}
                          </td>
                        )
                      };
                      return <td {...cell.getCellProps()} className='text-gray-600 pl-2 '>{cell.render('Cell')}</td>
                    })}
                    <td className='pl-2 text-primary underline cursor-pointer font-semibold' onClick={() => handlePayClick(row.original.treatmentId)}>Pay now</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </Styles>
    )
  }

  return (
    <div className='text-secondary md:w-1/2 xl:w-full bg-white rounded shadow flex flex-col px-4 md:p-10 py-6 md:py-10  flex-grow overflow-auto' style={{ minWidth: '300px', minHeight: '300px' }}>
        <div className='flex justify-between'>
            <h1 className="mb-5 text-2xl text-secondary">Pending payments</h1>
        </div>
        {isLoading && 
        <div className='flex justify-around min-h-170 pt-8'>
          <MoonLoader color={COLORS.colorPrimary}/>
        </div> 
        }
        <div className='space-y-4 overflow-auto'>
        {!isLoading ? 
          (unpaidTransactions.length ?
            renderTable()
            :
            'No pending payments')
          :
          ''
        }
        </div>
    </div>
  )
}

export default PendingPayments;

